const dafaults = {
    wp: {
        site: "https://admin.wegamotors.com/"
    },
    api: {
        base: "https://wega.wedigi.com.br/api/v1/",
        baseImage: "https://admin.wegamotors.com/wp-content/imagens/",
        rest: "https://admin.wegamotors.com/wp-json/wp/v2/"
    }
}

export default dafaults